import functions from "./functions.js";

$(function () {

    const $form = $('.newsletter-form');
    const form = $form[0];

    const lang = functions.getLang();
    let output = '';

    if (!form) {
        return;
    }

    $form.on('submit', e => {
        e.preventDefault();
        let $newsletterForm = $(e.currentTarget);
        $newsletterForm.find('.contact-btn').addClass('d-none');
        $newsletterForm.find('.contact-spinner').removeClass('d-none');
        $newsletterForm.find('.contact-spinner').addClass('d-flex');
        $newsletterForm.addClass('processing');
        
        let params = {};
        $.each($newsletterForm.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();

        //$output.html('').addClass('d-none');

        grecaptcha.ready(function () {
            grecaptcha.execute('6LdtqLwUAAAAAO-PrV_Cd-Ih9FrupyYbk8No6sus', { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);
                $.post('/services/mailchimp/', params).then(response => {
                    
                    $newsletterForm.addClass('done');
                    $newsletterForm.removeClass('processing');
                    $newsletterForm.find(".done-message").html(response.data).addClass(response.status ? 'bg-success' : 'bg-danger');

                    $newsletterForm.find('.contact-btn').removeClass('d-none');
                    $newsletterForm.find('.contact-spinner').addClass('d-none');
                    $newsletterForm.find('.contact-spinner').removeClass('d-flex');

                    setTimeout(() => { $newsletterForm.removeClass('done');  }, 4000);

                    if (response.status == true) {
                        // form.reset();
                    }
                });
            });
        });

    });

});